import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import globalClasses from 'theme/facility-globals.scss';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import CallToAction from './CallToAction';

const CTAStockIcons = ({ children }) => {
  const callouts = [0, 1, 2].map(index => ({
    icon: children[0 + index],
    header: children[3 + index],
    content: children[6 + index],
  }));

  return (
    <div className={globalClasses.section}>
      <Container>
        <Row>
          {callouts.map((props, index) => (
            <CallToAction
              key={`action-${index}`}
              {...props}
            />))
          }
        </Row>
      </Container>
    </div>
  );
};
CTAStockIcons.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Call to Action: Stock Icons', category: 'Call to Action' },
  {
    subsections: [
      { accepts: ['StockIcons'] },
      { accepts: ['StockIcons'] },
      { accepts: ['StockIcons'] },
      { accepts: ['HeaderText'] },
      { accepts: ['HeaderText'] },
      { accepts: ['HeaderText'] },
      { accepts: ['ContextBox'] },
      { accepts: ['ContextBox'] },
      { accepts: ['ContextBox'] },
    ],
    defaults: [
      ['StockIcons', { icon: 'icon icon-dollie-handcarts' }],
      ['StockIcons', { icon: 'icon icon-truck-rental' }],
      ['StockIcons', { icon: 'icon icon-pay-online' }],
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to Action 1',
              type: 'header-three',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to Action 2',
              type: 'header-three',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to Action 3',
              type: 'header-three',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['ContentBox', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to action text goes here',
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['ContentBox', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to action text goes here',
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['ContentBox', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Call to action text goes here',
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
    ],
  },
)(CTAStockIcons);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
